'use strict';

var _toConsumableArray = require('@babel/runtime/helpers/toConsumableArray');
var propTypes = require('./prop-types.js');
var isDefinedAndNotNull = require('./is-defined-and-not-null.js');
var getClosestScrollableElement = require('./get-closest-scrollable-element.js');
require('@babel/runtime/helpers/defineProperty');
require('prop-types/factoryWithTypeCheckers');
require('./constants.js');
require('./is-defined.js');
require('./is-null.js');
require('./is-html-element.js');
require('./get-safe-html-element.js');
require('./can-use-dom.js');
require('exenv');
require('./required-parameter.js');
require('./invalid-parameter-error.js');
require('@babel/runtime/helpers/classCallCheck');
require('@babel/runtime/helpers/inherits');
require('@babel/runtime/helpers/possibleConstructorReturn');
require('@babel/runtime/helpers/getPrototypeOf');
require('@babel/runtime/helpers/wrapNativeSuper');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _toConsumableArray__default = /*#__PURE__*/_interopDefaultCompat(_toConsumableArray);

var getScrollableContainersByElement = function getScrollableContainersByElement(element) {
  var closestScrollableContainer = getClosestScrollableElement(element);

  if (isDefinedAndNotNull(closestScrollableContainer)) {
    return [closestScrollableContainer].concat(_toConsumableArray__default["default"](getScrollableContainersByElement(closestScrollableContainer).flat()));
  }

  return [];
};

getScrollableContainersByElement.HELPER_ID = 'Gearz.JsUtils.getScrollableContainersByElement';
getScrollableContainersByElement.returnType = propTypes.arrayOfWithDescription(propTypes.instanceOf(HTMLElement), 'Array of parent scrollable elements.');
getScrollableContainersByElement.parameterTypes = {
  element: propTypes.instanceOfWithDescription(HTMLElement, 'Element to check.').isRequired
};
getScrollableContainersByElement.defaultParameters = {};

module.exports = getScrollableContainersByElement;
